var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMascotCollaborate3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.45 48.8879C34.6168 48.8879 33.9414 49.5621 33.9414 50.3935V58.2988V58.6752C33.9414 59.5069 34.6168 60.181 35.45 60.181H35.8271H36.2043H39.5985C40.64 60.181 41.4843 59.3382 41.4843 58.2988C41.4843 57.2593 40.64 56.4166 39.5985 56.4166H38.4671C38.0506 56.4166 37.7128 56.0798 37.7128 55.6637V50.3935C37.7128 49.5621 37.0374 48.8879 36.2043 48.8879H35.45Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.45 48.8879C34.6168 48.8879 33.9414 49.5621 33.9414 50.3935V58.2988V58.6752C33.9414 59.5069 34.6168 60.181 35.45 60.181H35.8271H36.2043H39.5985C40.64 60.181 41.4843 59.3382 41.4843 58.2988C41.4843 57.2593 40.64 56.4166 39.5985 56.4166H38.4671C38.0506 56.4166 37.7128 56.0798 37.7128 55.6637V50.3935C37.7128 49.5621 37.0374 48.8879 36.2043 48.8879H35.45Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6281 10.8198C66.6276 10.8198 66.6276 10.8195 66.6276 10.8192C66.6281 10.7859 66.6286 10.7525 66.6286 10.719V4.52721C66.6286 1.42489 63.5677 -0.754165 60.629 0.256238L39.2288 7.61431C38.275 7.94221 37.2388 7.94271 36.2847 7.61561L14.7958 0.248828C11.8579 -0.75835 8.8 1.42054 8.8 4.52113V10.8198V13.9826V35.2851C8.8 36.5326 7.78689 37.5438 6.53714 37.5438H3.82171C1.71104 37.5438 0 39.2516 0 41.3584C0 43.4651 1.71104 45.173 3.82171 45.173H71.6069C73.7174 45.173 75.4286 43.4651 75.4286 41.3584C75.4286 39.2516 73.7174 37.5438 71.6069 37.5438H68.8914C67.6418 37.5438 66.6286 36.5326 66.6286 35.2851V10.8203C66.6286 10.82 66.6286 10.8198 66.6281 10.8198Z",
    fill: "#FFBC57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79997 30.0657H66.6285V35.2856C66.6285 36.5331 67.6418 37.5443 68.8914 37.5443H6.53711C7.78686 37.5443 8.79997 36.5331 8.79997 35.2856V30.0657Z",
    fill: "#5775FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_291_13227",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 15,
    width: 16,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6267 22.5364C66.6267 18.3783 63.2497 15.0076 59.0839 15.0076C54.9181 15.0076 51.541 18.3783 51.541 22.5364V30.0651C51.541 34.2232 54.9181 37.5939 59.0839 37.5939C63.2497 37.5939 66.6267 34.2232 66.6267 30.0651V22.5364Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_291_13227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6267 22.5364C66.6267 18.3783 63.2497 15.0076 59.0839 15.0076C54.9181 15.0076 51.541 18.3783 51.541 22.5364V30.0651C51.541 34.2232 54.9181 37.5939 59.0839 37.5939C63.2497 37.5939 66.6267 34.2232 66.6267 30.0651V22.5364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2208 23.3967C59.1318 23.7177 59.084 24.0559 59.084 24.4053V28.1963C59.084 30.2753 60.7726 31.9606 62.8554 31.9606C64.9382 31.9606 66.6268 30.2753 66.6268 28.1963V24.4053C66.6268 22.3263 64.9382 20.6409 62.8554 20.6409C62.4939 20.6409 62.1444 20.6916 61.8135 20.7863C62.4315 21.0954 62.8554 21.7332 62.8554 22.47V22.6914C62.8554 23.7309 62.0111 24.5736 60.9697 24.5736C60.1782 24.5736 59.5003 24.0867 59.2208 23.3967Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotCollaborate3);
export default __webpack_public_path__ + "static/media/mascot-collaborate-3.5e3807f06ee5e275981b7c106b614b79.svg";
export { ForwardRef as ReactComponent };